<template>
    <kakao-map v-if="place?.geolocation" v-bind="props_map" width="100%" height="100%" :draggable="false" :scrollwheel="false" disableDoubleClick disableDoubleClickZoom>
        <kakao-map-marker slot-scope="{ on, attrs }" v-on="on" v-bind="{ ...props_marker, ...attrs }" />
    </kakao-map>
</template>

<script>
import KakaoMap from "@/components/plugins/kakao/kakao-map.vue";
import KakaoMapMarker from "@/components/plugins/kakao/kakao-map-marker.vue";
export default {
    components: {
        KakaoMap,
        KakaoMapMarker,
    },
    props: {
        place: { type: Object },
        level: { type: [Number, String] },
    },
    computed: {
        props_map() {
            const { level } = this;
            const [lng, lat] = this.place?.geolocation?.coordinates || [];
            const props = {
                level,
                width: "100%",
                height: "37vh",
                centerPosition: { lng, lat },
            };
            if (!level) delete props.level;
            return props;
        },
        props_marker() {
            return {
                ...this.place,
                lat: this.place?.geolocation?.coordinates[1],
                lng: this.place?.geolocation?.coordinates[0],
                address: `${this.place?.address1} ${this.place?.address2}`,
                // content: `<div>${this.place?.address1} ${this.place?.address2}</div>`,
            };
        },
    },
};
</script>

<style></style>
